import {
    LIST_CUSTOMER_LOAN,
    LIST_EMPLOYEE_LOAN, LIST_ZELLE_LOAN,
    SAVE_CUSTOMER_LOAN, SAVE_EMPLOYEE_LOAN, SAVE_ZELLE_LOAN,
    STORE_CUSTOMER_LOAN,
    STORE_EMPLOYEE_LOAN, STORE_ZELLE_LOAN,
} from '../../constants/loan';

export const saveCustomerLoan = (data,callback) => ({
    type: SAVE_CUSTOMER_LOAN,
    data,
    callback
})


export const listCustomerLoan = (data) => ({
    type: LIST_CUSTOMER_LOAN,
    data
})

export const storeCustomerLoan = (loanHistory) => ({
    type: STORE_CUSTOMER_LOAN,
    loanHistory
})


export const saveEmployeeLoan = (data,callback) => ({
    type: SAVE_EMPLOYEE_LOAN,
    data,
    callback
})


export const listEmployeeLoan = (data) => ({
    type: LIST_EMPLOYEE_LOAN,
    data
})

export const storeEmployeeLoan = (shortHistory) => ({
    type: STORE_EMPLOYEE_LOAN,
    shortHistory
})


export const saveZelleLoan = (data,callback) => ({
    type: SAVE_ZELLE_LOAN,
    data,
    callback
})


export const listZelleLoan = (data) => ({
    type: LIST_ZELLE_LOAN,
    data
})

export const storeZelleLoan = (zelleHistory,totalBalance,zelleTable) => ({
    type: STORE_ZELLE_LOAN,
    zelleHistory,
    totalBalance,
    zelleTable
})

